export default __webpack_public_path__ + "static/media/Vector 187.6920df75.svg";